import { useEffect, useState } from "react";
import api from "../utils/axiosInstance";
import UserAddModal from "../components/UserAddModal";
import UserEditModal from "../components/UserEditModal";
import ChangePasswordModal from "../components/ChangePasswordModal"; // Подключаем новый компонент
import "../styles/UserList.css";

const UserList = () => {
    const [users, setUsers] = useState([]);
    const [error, setError] = useState("");
    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const [isAddModalOpen, setAddModalOpen] = useState(false);
    const [isPasswordModalOpen, setPasswordModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await api.get("/users", {
                headers: { Authorization: `Bearer ${token}` },
            });
            setUsers(response.data);
        } catch (err) {
            setError("User loading error");
        }
    };

    const handleAddUser = async (userData) => {
        try {
            const token = localStorage.getItem("token");
            await api.post(
                "/users",
                JSON.stringify(userData),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`, // если используется авторизация
                    },
                }
            );
            setAddModalOpen(false);
            fetchUsers();
        } catch (err) {
            console.error("User creation failed:", err);
        }
    };


    const handleDelete = async (id) => {
        if (!window.confirm("Delete user?")) return;

        try {
            const token = localStorage.getItem("token");
            await api.delete(`/users/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            fetchUsers();
        } catch (err) {
            setError("User deletion error");
        }
    };

    return (
        <div className="user-container">
            <h1>👥 Users</h1>
            {error && <p className="text-red-500">{error}</p>}

            <button onClick={() => setAddModalOpen(true)} className="add-user-button">
                ➕ Add User
            </button>

            <div className="table-scroll-wrapper">
            <table className="user-table">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Email</th>
                    <th>Roles</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {users.map((user) => (
                    <tr key={user.id}>
                        <td>{user.id}</td>
                        <td>{user.email}</td>
                        <td>{user.roles.join(", ")}</td>
                        <td className="user-actions">
                            <button
                                className="edit-button"
                                onClick={() => {
                                    setSelectedUser(user);
                                    setEditModalOpen(true);
                                }}
                            >
                                ✏️ Edit
                            </button>
                            <button
                                className="password-button"
                                onClick={() => {
                                    setSelectedUser(user);
                                    setPasswordModalOpen(true);
                                }}
                            >
                                🔑 Change password
                            </button>
                            <button
                                className="delete-button"
                                onClick={() => handleDelete(user.id)}
                            >
                                🗑️ Delete
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            </div>

            {/* Модальные окна */}
            <UserAddModal isOpen={isAddModalOpen} onClose={() => setAddModalOpen(false)} onAddUser={handleAddUser} />
            {selectedUser && (
                <>
                    <UserEditModal
                        isOpen={isEditModalOpen}
                        onClose={() => setEditModalOpen(false)}
                        user={selectedUser}
                        onUpdateUser={fetchUsers}
                    />
                    <ChangePasswordModal
                        isOpen={isPasswordModalOpen}
                        onClose={() => setPasswordModalOpen(false)}
                        userId={selectedUser.id}
                    />
                </>
            )}
        </div>
    );
};

export default UserList;
